<template>
  <div class="addExam">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
      <el-form-item label="考试名称" prop="name">
        <el-input v-model="ruleForm.name" placeholder="考试名称"></el-input>
      </el-form-item>
      <el-form-item label="考试地点" prop="address">
        <el-input v-model="ruleForm.address" placeholder="考试地点"></el-input>
      </el-form-item>
      <el-form-item label="所属父考试" prop="parentId">
        <el-select v-model="ruleForm.parentId" placeholder="所属父考试">
          <el-option v-for="item in option" :key="item.id" :label="item.name" :value="item.pid">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <div class="formItem">
        <el-form-item  prop="checked">
          <el-checkbox v-model="ruleForm.checked"></el-checkbox>
        </el-form-item>
        <el-form-item prop="stage" label="考生分阶段考试">
          <el-input v-model="ruleForm.stage">
            <template slot="append">阶段</template>
          </el-input>
        </el-form-item>
      </div> -->
      <el-form-item label="考试顺序" prop="examOrder">
        <el-select v-model="ruleForm.examOrder" placeholder="考试顺序">
          <el-option label="轮询" :value="3"></el-option>
          <el-option label="顺序" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排考方式" prop="examWay">
        <el-select v-model="ruleForm.examWay" placeholder="考试顺序">
          <el-option label="已考场分组" :value="1"></el-option>
          <el-option label="已考站分组" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="checked">
        <el-checkbox v-model="ruleForm.checked">要求考生同时进出考站（考站的时间采用最长考站时间）</el-checkbox>
      </el-form-item>
      <el-form-item prop="realtime">
        <el-checkbox v-model="ruleForm.realtime">实时发布成绩</el-checkbox>
      </el-form-item>
      <el-form-item label="考试时间" prop="">

        <el-button type="primary" @click="addTime()" size="medium" class="add">新增时间</el-button>
        <el-table :data="timeList" border style="width: 1000x">

          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="address" label="开始时间">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.begin_dt" @blur="blurTime(scope.row)" class="time" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="开始时间">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="结束时间">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.end_dt" class="time" format="yyyy-MM-dd HH:mm" @blur="blurTime1(scope.row)" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="结束时间">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="时长">
            <template slot-scope="scope">
              {{formatDuring(new Date(scope.row.end_dt) - new Date(scope.row.begin_dt))}}

            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="godetele(scope.$index)">删除</el-button>

            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" size="medium">保存</el-button>
        <el-button @click="resetForm('ruleForm')" size="medium">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      option: [],
      ruleForm: {
        name: '',
        address: '',
        parentId: '',
        checked: false,
        stage: '',
        examOrder: 3,
        examWay: 1,
        realtime: false,
      },
      rules: {
        name: [
          { required: true, message: '请输入考试名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请选择考试地点', trigger: 'change' }
        ],
      },
      timeList: [],
      index: '',
    };
  },
  computed: {

  },
  created() {
    this.getData()
  },
  methods: {

    godetele(index) {

      this.timeList.splice(index, 1)
    },
    blurTime(row) {

      var end = new Date(row.begin_dt).getTime() + 3 * 60 * 60 * 1000
      row.end_dt = new Date(end)
    },
    blurTime1(row) {
      return;
      if (row.end_dt && row.begin_dt) {
        console.log(new Date(row.end_dt) - new Date(row.begin_dt))
        if (new Date(row.end_dt) - new Date(row.begin_dt) > 0) {
          var ms = new Date(row.end_dt) - new Date(row.begin_dt)
          this.formatDuring(ms)
        }
      }


    },
    formatDuring(millisecond) {

      var days = parseInt(millisecond / (1000 * 60 * 60 * 24));

      var hours = parseInt((millisecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      var minutes = parseInt((millisecond % (1000 * 60 * 60)) / (1000 * 60));

      //   var seconds = (millisecond % (1000 * 60)) / 1000;

      return days + " 天 " + hours + " 小时 " + minutes + " 分钟 ";
      7
    },


    //新增时间
    addTime() {
      this.timeList.push({
        begin_dt: new Date(),
        end_dt: new Date((new Date().getTime() + 3 * 60 * 60 * 1000))
      })
    },
    // 获取全部的课程列表
    getData() {
      this.$http.examsList({
page_size:10000,
        name: '',
        page: 1
      })
        .then(res => {
          console.log(res.data)
          this.option = res.data;

        })
        .catch(err => {
          console.log(err);
        })
    },
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.timeList.length == 0) {
            this.$message.error("请选择考试时间")
            return false;
          }

          var arr = [];
          var objs = {};
          for (var i = 0; i < this.timeList.length; i++) {
            this.index = (i + 1).toString();
            this.timeList[i].begin_dt = this.$format(this.timeList[i].begin_dt, 'yyyy-MM-dd hh:mm')
            this.timeList[i].end_dt = this.$format(this.timeList[i].end_dt, 'yyyy-MM-dd hh:mm')
            var obj = {

            }

            objs[this.index.toString()] = this.timeList[i];
          }
          console.log(objs)


          let params = {
            name: this.ruleForm.name,
            address: this.ruleForm.address,
            pid: this.ruleForm.parentId,
            sequence_cate_1: this.ruleForm.examOrder,
            sequence_mode: this.ruleForm.examWay,
            same_time: this.ruleForm.checked ? 1 : 0,
            real_push: this.ruleForm.realtime ? 0 : 1,
            time: objs

          };
          console.log(params)
          this.$http
            .addExam(params)
            .then(res => {
              this.$message.success("保存成功")
                this.$router.push({
                    name: 'examSeting',
                    query: {
                        id: res.data.id
                    }
                })

            })
            .catch(err => {
              console.log(err);
            });


        } else {
          this.$message.error("请填写必填项")
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1)


    }
  },
};
</script>

<style  lang="less">
.addExam {
  .time {
    width: 174px !important;

    //   input{
    //      width:174px!important;
    //   }
  }
  .add {
    margin-bottom: 20px;
  }
  min-width: 600px;
  max-width: 1000px;
  .formItem {
    overflow: hidden;
    display: flex;
    .el-form-item {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/examManage/addExam.vue